import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { StarIcon, CheckCircleIcon, ShieldCheckIcon, MessageCircleIcon, HeartIcon, ClockIcon, FilterIcon, SearchIcon, UserIcon, ThumbsUpIcon, ThumbsDownIcon, ChevronDownIcon, EyeIcon } from 'lucide-react';
export const DealerPage = () => {
  const [activeTab, setActiveTab] = useState('listings');
  const [showFilters, setShowFilters] = useState(false);
  // Sample data for the dealer
  const dealer = {
    id: 'techhub-singapore',
    name: 'TechHub Singapore',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jPSGPmPa1L8X2XEzVvetCe/image.png',
    rating: 5.0,
    reviewCount: 22556,
    ordersCompleted: 18614,
    yearsActive: '7y 6m',
    responseTime: 'Within 2 hours',
    isVerified: true,
    isCertified: true,
    description: 'Your trusted one-stop mobile provider in Singapore. ISO Certified and CaseTrust Accredited. Experience the difference today and exceed your expectations with Mister Mobile. Chat with me anytime between 7am-11pm.',
    operatingHours: '8:00 AM - 11:00 PM'
  };
  // Sample products for listings
  const products = [{
    id: 'iphone-15-pro-max',
    name: 'iPhone 15 Pro Max 256GB',
    price: 1299,
    condition: 'Certified',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/adSmqXZtwMRaADCVDQGH75/image.png',
    likes: 121,
    views: 2400,
    isNew: false
  }, {
    id: 'samsung-s24-ultra',
    name: 'Samsung Galaxy S24 Ultra',
    price: 1199,
    condition: 'Like New',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9CLQER3mW4v2Jv4RPGHc1W/image.png',
    likes: 87,
    views: 1850,
    isNew: false
  }, {
    id: 'macbook-air-m2',
    name: 'MacBook Air M2',
    price: 999,
    condition: 'Refurbished',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qcMnDWqru55oVRbBxJg3SM/image.png',
    likes: 56,
    views: 1200,
    isNew: false
  }, {
    id: 'airpods-pro-2',
    name: 'AirPods Pro 2nd Gen',
    price: 189,
    condition: 'Brand New',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/j1haWtLZkePnbgPEWS6oLi/image.png',
    likes: 168,
    views: 3100,
    isNew: true
  }, {
    id: 'iphone-14-pro',
    name: 'iPhone 14 Pro 256GB',
    price: 899,
    condition: 'Certified',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a1zZe5YfTvqp2TmKQmQWqk/image.png',
    likes: 92,
    views: 1750,
    isNew: false
  }, {
    id: 'samsung-galaxy-s23',
    name: 'Samsung Galaxy S23',
    price: 749,
    condition: 'Excellent',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xcWkHhZn7peZ2jG4h2eosT/image.png',
    likes: 47,
    views: 980,
    isNew: false
  }];
  // Sample reviews
  const reviews = [{
    id: 'review1',
    rating: 5,
    title: 'Amazing service and product quality!',
    content: 'Received my iPhone in perfect condition. The delivery was super fast, and the phone looks brand new. Will definitely buy from TechHub again!',
    customerName: 'Sarah L.',
    verifiedPurchase: true,
    purchaseDate: 'May 15, 2023',
    daysAgo: 3,
    helpful: 24,
    notHelpful: 1,
    productName: 'iPhone 14 Pro',
    productImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a1zZe5YfTvqp2TmKQmQWqk/image.png'
  }, {
    id: 'review2',
    rating: 5,
    content: 'Second time purchasing from TechHub. Their certified phones are as good as new but at much better prices. Customer service is top-notch!',
    customerName: 'Michael T.',
    verifiedPurchase: true,
    purchaseDate: 'May 10, 2023',
    daysAgo: 8,
    helpful: 18,
    notHelpful: 0,
    productName: 'Samsung Galaxy S23',
    productImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xcWkHhZn7peZ2jG4h2eosT/image.png'
  }, {
    id: 'review3',
    rating: 4,
    content: 'Good experience overall. The MacBook works perfectly, but delivery took a day longer than expected. Still happy with my purchase.',
    customerName: 'David W.',
    verifiedPurchase: true,
    purchaseDate: 'May 5, 2023',
    daysAgo: 13,
    helpful: 7,
    notHelpful: 1,
    productName: 'MacBook Air M2',
    productImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qcMnDWqru55oVRbBxJg3SM/image.png'
  }];
  // Filter brands
  const popularBrands = ['Apple', 'Samsung', 'Oppo', 'Xiaomi'];
  // Render condition badge with appropriate color
  const renderConditionBadge = condition => {
    let bgColor = 'bg-gray-100 text-gray-800';
    switch (condition) {
      case 'Brand New':
        bgColor = 'bg-green-100 text-green-800';
        break;
      case 'Like New':
      case 'Excellent':
        bgColor = 'bg-blue-100 text-blue-800';
        break;
      case 'Certified':
        bgColor = 'bg-red-100 text-red-800';
        break;
      case 'Refurbished':
        bgColor = 'bg-orange-100 text-orange-800';
        break;
      default:
        break;
    }
    return <span className={`text-xs font-medium px-2 py-1 rounded-full ${bgColor}`} data-id="element-2593">
        {condition}
      </span>;
  };
  return <div className="bg-gray-50 min-h-screen pb-12" data-id="element-2594">
      {/* Hero Banner */}
      <div className="bg-gradient-to-r from-red-500 to-red-600 text-white" data-id="element-2595">
        <div className="container mx-auto px-4 py-8 relative" data-id="element-2596">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-6" data-id="element-2597">
            <div className="flex-shrink-0" data-id="element-2598">
              <img src={dealer.logo} alt={dealer.name} className="w-24 h-24 rounded-full border-4 border-white shadow-md object-cover" data-id="element-2599" />
            </div>
            <div className="flex-grow text-center md:text-left" data-id="element-2600">
              <div className="flex items-center justify-center md:justify-start mb-2" data-id="element-2601">
                <h1 className="text-3xl font-bold mr-2" data-id="element-2602">{dealer.name}</h1>
                {dealer.isVerified && <CheckCircleIcon className="h-5 w-5 text-white" data-id="element-2603" />}
              </div>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mb-4" data-id="element-2604">
                <div className="flex items-center" data-id="element-2605">
                  <StarIcon className="h-5 w-5 text-yellow-300 fill-current" data-id="element-2606" />
                  <span className="ml-1 font-bold" data-id="element-2607">{dealer.rating}</span>
                  <span className="ml-1 text-white text-opacity-90" data-id="element-2608">
                    ({dealer.reviewCount} reviews)
                  </span>
                </div>
                <div className="flex items-center" data-id="element-2609">
                  <ShieldCheckIcon className="h-5 w-5 text-white" data-id="element-2610" />
                  <span className="ml-1" data-id="element-2611">{dealer.ordersCompleted} Orders</span>
                </div>
                <div className="flex items-center" data-id="element-2612">
                  <UserIcon className="h-5 w-5 text-white" data-id="element-2613" />
                  <span className="ml-1" data-id="element-2614">Joined {dealer.yearsActive}</span>
                </div>
              </div>
              <p className="text-white text-opacity-90 max-w-2xl mb-4 text-sm md:text-base" data-id="element-2615">
                {dealer.description}
              </p>
              <div className="flex flex-wrap gap-3 justify-center md:justify-start" data-id="element-2616">
                {dealer.isCertified && <div className="bg-white bg-opacity-20 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-2617">
                    <ShieldCheckIcon className="h-4 w-4 mr-1" data-id="element-2618" />
                    <span data-id="element-2619">Certified Partner</span>
                  </div>}
                <div className="bg-white bg-opacity-20 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-2620">
                  <ClockIcon className="h-4 w-4 mr-1" data-id="element-2621" />
                  <span data-id="element-2622">Responds {dealer.responseTime}</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-3 mt-4 md:mt-0" data-id="element-2623">
              <button className="bg-white text-red-600 font-medium px-5 py-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-2624">
                Follow
              </button>
              <button className="bg-black text-white font-medium px-5 py-2 rounded-full hover:bg-gray-800 transition-colors flex items-center justify-center" data-id="element-2625">
                <MessageCircleIcon className="h-4 w-4 mr-2" data-id="element-2626" />
                Chat Now
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Navigation Tabs */}
      <div className="sticky top-16 bg-white shadow-sm z-20" data-id="element-2627">
        <div className="container mx-auto px-4" data-id="element-2628">
          <div className="flex overflow-x-auto hide-scrollbar" data-id="element-2629">
            <button className={`px-6 py-4 font-medium text-sm whitespace-nowrap ${activeTab === 'listings' ? 'text-red-500 border-b-2 border-red-500' : 'text-gray-600 hover:text-gray-900'}`} onClick={() => setActiveTab('listings')} data-id="element-2630">
              Listings
            </button>
            <button className={`px-6 py-4 font-medium text-sm whitespace-nowrap ${activeTab === 'reviews' ? 'text-red-500 border-b-2 border-red-500' : 'text-gray-600 hover:text-gray-900'}`} onClick={() => setActiveTab('reviews')} data-id="element-2631">
              Reviews
            </button>
            <button className={`px-6 py-4 font-medium text-sm whitespace-nowrap ${activeTab === 'about' ? 'text-red-500 border-b-2 border-red-500' : 'text-gray-600 hover:text-gray-900'}`} onClick={() => setActiveTab('about')} data-id="element-2632">
              About
            </button>
            <button className={`px-6 py-4 font-medium text-sm whitespace-nowrap ${activeTab === 'policies' ? 'text-red-500 border-b-2 border-red-500' : 'text-gray-600 hover:text-gray-900'}`} onClick={() => setActiveTab('policies')} data-id="element-2633">
              Policies
            </button>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 mt-6" data-id="element-2634">
        {/* Listings Tab */}
        {activeTab === 'listings' && <div data-id="element-2635">
            {/* Recent Activity */}
            <div className="bg-white p-4 rounded-lg shadow-sm mb-6" data-id="element-2636">
              <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-2637">
                <ClockIcon className="h-4 w-4 mr-1 text-blue-500" data-id="element-2638" />
                <span data-id="element-2639">Recent activity: </span>
                <span className="ml-2 text-gray-700" data-id="element-2640">
                  John just purchased iPhone 14 Pro • 2 minutes ago
                </span>
              </div>
              <div className="h-1 w-full bg-gray-100 rounded-full overflow-hidden" data-id="element-2641">
                <div className="h-full bg-blue-500 rounded-full w-3/4 animate-pulse" data-id="element-2642"></div>
              </div>
            </div>
            {/* Filter and Search */}
            <div className="mb-6" data-id="element-2643">
              <div className="mb-4" data-id="element-2644">
                <h3 className="text-lg font-medium text-gray-700 mb-2" data-id="element-2645">
                  Popular Brands
                </h3>
                <div className="flex flex-wrap gap-2" data-id="element-2646">
                  {popularBrands.map(brand => <button key={brand} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:border-blue-500 hover:text-blue-500 transition-colors" data-id="element-2647">
                      {brand}
                    </button>)}
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-2648">
                <div className="relative flex-grow" data-id="element-2649">
                  <input type="text" placeholder="Search listings..." className="w-full py-2 pl-4 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-2650" />
                  <SearchIcon className="absolute right-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-2651" />
                </div>
                <div className="relative" data-id="element-2652">
                  <button onClick={() => setShowFilters(!showFilters)} className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center gap-2 hover:bg-gray-50" data-id="element-2653">
                    <FilterIcon className="h-5 w-5 text-gray-500" data-id="element-2654" />
                    <span data-id="element-2655">Filters</span>
                  </button>
                  {showFilters && <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-30 p-4" data-id="element-2656">
                      <div className="mb-4" data-id="element-2657">
                        <h4 className="font-medium text-gray-700 mb-2" data-id="element-2658">Sort</h4>
                        <div className="space-y-2" data-id="element-2659">
                          <label className="flex items-center" data-id="element-2660">
                            <input type="radio" name="sort" className="h-4 w-4 text-blue-600" defaultChecked data-id="element-2661" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2662">
                              Recent
                            </span>
                          </label>
                          <label className="flex items-center" data-id="element-2663">
                            <input type="radio" name="sort" className="h-4 w-4 text-blue-600" data-id="element-2664" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2665">
                              Price - High to Low
                            </span>
                          </label>
                          <label className="flex items-center" data-id="element-2666">
                            <input type="radio" name="sort" className="h-4 w-4 text-blue-600" data-id="element-2667" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2668">
                              Price - Low to High
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="mb-4" data-id="element-2669">
                        <h4 className="font-medium text-gray-700 mb-2" data-id="element-2670">
                          Item Condition
                        </h4>
                        <div className="space-y-2" data-id="element-2671">
                          <label className="flex items-center" data-id="element-2672">
                            <input type="checkbox" className="h-4 w-4 text-blue-600" data-id="element-2673" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2674">
                              Brand new
                            </span>
                          </label>
                          <label className="flex items-center" data-id="element-2675">
                            <input type="checkbox" className="h-4 w-4 text-blue-600" data-id="element-2676" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2677">
                              Like new
                            </span>
                          </label>
                          <label className="flex items-center" data-id="element-2678">
                            <input type="checkbox" className="h-4 w-4 text-blue-600" data-id="element-2679" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2680">
                              Lightly used
                            </span>
                          </label>
                          <label className="flex items-center" data-id="element-2681">
                            <input type="checkbox" className="h-4 w-4 text-blue-600" data-id="element-2682" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2683">
                              Well used
                            </span>
                          </label>
                          <label className="flex items-center" data-id="element-2684">
                            <input type="checkbox" className="h-4 w-4 text-blue-600" data-id="element-2685" />
                            <span className="ml-2 text-sm text-gray-700" data-id="element-2686">
                              Heavily used
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-2687">
                        <button className="text-gray-600 text-sm hover:text-gray-900" data-id="element-2688">
                          Reset
                        </button>
                        <button className="bg-blue-600 text-white px-4 py-1 rounded-md text-sm hover:bg-blue-700" data-id="element-2689">
                          Apply
                        </button>
                      </div>
                    </div>}
                </div>
              </div>
            </div>
            {/* Products Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-2690">
              {products.map(product => <div key={product.id} className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-all duration-200" data-id="element-2691">
                  <div className="relative" data-id="element-2692">
                    <img src={product.image} alt={product.name} className="w-full h-48 object-contain p-4" data-id="element-2693" />
                    <div className="absolute top-2 left-2" data-id="element-2694">
                      {product.condition === 'Certified' && <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-2695">
                          Certified
                        </span>}
                      {product.isNew && <span className="bg-green-500 text-white text-xs font-bold px-2 py-1 rounded ml-1" data-id="element-2696">
                          NEW
                        </span>}
                    </div>
                    <button className="absolute top-2 right-2 bg-white rounded-full p-1.5 shadow hover:bg-gray-100" data-id="element-2697">
                      <HeartIcon className="h-5 w-5 text-gray-400 hover:text-red-500" data-id="element-2698" />
                    </button>
                  </div>
                  <div className="p-4 border-t border-gray-100" data-id="element-2699">
                    <h3 className="font-medium text-gray-800 mb-1" data-id="element-2700">
                      {product.name}
                    </h3>
                    <div className="flex justify-between items-center mb-2" data-id="element-2701">
                      <div className="text-lg font-bold text-gray-900" data-id="element-2702">
                        ${product.price}
                      </div>
                      {renderConditionBadge(product.condition)}
                    </div>
                    <div className="flex items-center text-xs text-gray-500 mt-2" data-id="element-2703">
                      <div className="flex items-center mr-3" data-id="element-2704">
                        <HeartIcon className="h-3 w-3 mr-1" data-id="element-2705" />
                        <span data-id="element-2706">{product.likes}</span>
                      </div>
                      <div className="flex items-center" data-id="element-2707">
                        <EyeIcon className="h-3 w-3 mr-1" data-id="element-2708" />
                        <span data-id="element-2709">{product.views}</span>
                      </div>
                      <div className="ml-auto" data-id="element-2710">
                        <span className="text-green-600 font-medium" data-id="element-2711">
                          In Stock
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 flex justify-between items-center" data-id="element-2712">
                    <span className="text-xs text-gray-500" data-id="element-2713">
                      TechHub Singapore
                    </span>
                    <button className="bg-black text-white text-xs px-3 py-1 rounded-full hover:bg-gray-800" data-id="element-2714">
                      Quick Buy
                    </button>
                  </div>
                </div>)}
            </div>
          </div>}
        {/* Reviews Tab */}
        {activeTab === 'reviews' && <div data-id="element-2715">
            {/* Rating Summary */}
            <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-2716">
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2717">
                <div className="md:w-1/3 flex flex-col items-center justify-center" data-id="element-2718">
                  <div className="text-5xl font-bold text-gray-900" data-id="element-2719">
                    {dealer.rating}
                  </div>
                  <div className="flex mt-2 mb-1" data-id="element-2720">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400" fill="currentColor" data-id="element-2721" />)}
                  </div>
                  <div className="text-gray-500 text-sm" data-id="element-2722">
                    {dealer.reviewCount} reviews
                  </div>
                </div>
                <div className="md:w-2/3" data-id="element-2723">
                  <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-2724">
                    Rating Breakdown
                  </h3>
                  <div className="space-y-3" data-id="element-2725">
                    {[5, 4, 3, 2, 1].map(stars => {
                  // Calculate percentage based on stars
                  let percentage = 0;
                  switch (stars) {
                    case 5:
                      percentage = 84;
                      break;
                    case 4:
                      percentage = 15;
                      break;
                    case 3:
                      percentage = 0;
                      break;
                    case 2:
                      percentage = 1;
                      break;
                    case 1:
                      percentage = 0;
                      break;
                    default:
                      percentage = 0;
                  }
                  return <div key={stars} className="flex items-center" data-id="element-2726">
                          <div className="w-16 text-sm text-gray-600" data-id="element-2727">
                            {stars} star
                          </div>
                          <div className="flex-1 mx-3" data-id="element-2728">
                            <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-2729">
                              <div className="h-full bg-yellow-400 rounded-full" style={{
                          width: `${percentage}%`
                        }} data-id="element-2730" />
                            </div>
                          </div>
                          <div className="w-12 text-sm text-gray-600 text-right" data-id="element-2731">
                            {percentage}%
                          </div>
                        </div>;
                })}
                  </div>
                </div>
              </div>
            </div>
            {/* Reviews List */}
            <div className="space-y-6" data-id="element-2732">
              {reviews.map(review => <div key={review.id} className="bg-white rounded-lg shadow-sm p-6" data-id="element-2733">
                  <div className="flex items-center mb-1" data-id="element-2734">
                    <div className="flex" data-id="element-2735">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < review.rating ? 'text-yellow-400' : 'text-gray-300'}`} fill={i < review.rating ? 'currentColor' : 'none'} data-id="element-2736" />)}
                    </div>
                    <span className="ml-auto text-gray-500 text-sm" data-id="element-2737">
                      {review.daysAgo} days ago
                    </span>
                  </div>
                  {review.title && <h3 className="font-bold text-gray-900 mb-2" data-id="element-2738">
                      {review.title}
                    </h3>}
                  <p className="text-gray-700 mb-4" data-id="element-2739">{review.content}</p>
                  <div className="flex items-center mb-4" data-id="element-2740">
                    <div className="flex items-center" data-id="element-2741">
                      <div className="h-8 w-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-medium mr-2" data-id="element-2742">
                        {review.customerName.charAt(0)}
                      </div>
                      <span className="font-medium text-gray-800" data-id="element-2743">
                        {review.customerName}
                      </span>
                    </div>
                    {review.verifiedPurchase && <div className="ml-4 flex items-center text-sm text-green-700" data-id="element-2744">
                        <CheckCircleIcon className="h-4 w-4 mr-1" data-id="element-2745" />
                        <span data-id="element-2746">Purchased on {review.purchaseDate}</span>
                      </div>}
                  </div>
                  <div className="flex items-center bg-gray-50 p-3 rounded-lg mb-4" data-id="element-2747">
                    <img src={review.productImage} alt={review.productName} className="w-12 h-12 object-contain mr-4" data-id="element-2748" />
                    <div data-id="element-2749">
                      <div className="font-medium text-gray-800" data-id="element-2750">
                        {review.productName}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center text-sm" data-id="element-2751">
                    <div className="text-gray-500" data-id="element-2752">
                      Was this review helpful?
                    </div>
                    <button className="ml-4 flex items-center text-gray-700 hover:text-blue-600" data-id="element-2753">
                      <ThumbsUpIcon className="h-4 w-4 mr-1" data-id="element-2754" />
                      <span data-id="element-2755">{review.helpful}</span>
                    </button>
                    <button className="ml-4 flex items-center text-gray-700 hover:text-blue-600" data-id="element-2756">
                      <ThumbsDownIcon className="h-4 w-4 mr-1" data-id="element-2757" />
                      <span data-id="element-2758">{review.notHelpful}</span>
                    </button>
                  </div>
                </div>)}
              <div className="text-center" data-id="element-2759">
                <button className="text-blue-600 font-medium hover:underline" data-id="element-2760">
                  Load more reviews
                </button>
              </div>
            </div>
          </div>}
        {/* About Tab */}
        {activeTab === 'about' && <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-2761">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2762">
              About TechHub Singapore
            </h2>
            <div className="space-y-6" data-id="element-2763">
              <p className="text-gray-700" data-id="element-2764">
                TechHub Singapore is your trusted one-stop mobile provider in
                Singapore. We specialize in offering high-quality certified
                refurbished smartphones, tablets, and laptops at competitive
                prices.
              </p>
              <div data-id="element-2765">
                <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2766">
                  Company Information
                </h3>
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2767">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2768">
                    <div data-id="element-2769">
                      <div className="text-sm text-gray-500" data-id="element-2770">
                        Business Registration
                      </div>
                      <div className="font-medium" data-id="element-2771">202012345K</div>
                    </div>
                    <div data-id="element-2772">
                      <div className="text-sm text-gray-500" data-id="element-2773">Established</div>
                      <div className="font-medium" data-id="element-2774">2018</div>
                    </div>
                    <div data-id="element-2775">
                      <div className="text-sm text-gray-500" data-id="element-2776">Location</div>
                      <div className="font-medium" data-id="element-2777">Singapore</div>
                    </div>
                    <div data-id="element-2778">
                      <div className="text-sm text-gray-500" data-id="element-2779">
                        Operating Hours
                      </div>
                      <div className="font-medium" data-id="element-2780">
                        8:00 AM - 11:00 PM Daily
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-2781">
                <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2782">
                  Certifications
                </h3>
                <div className="flex flex-wrap gap-4" data-id="element-2783">
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center" data-id="element-2784">
                    <ShieldCheckIcon className="h-8 w-8 text-blue-600 mr-3" data-id="element-2785" />
                    <div data-id="element-2786">
                      <div className="font-medium" data-id="element-2787">ISO Certified</div>
                      <div className="text-sm text-gray-500" data-id="element-2788">
                        Quality Management System
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg flex items-center" data-id="element-2789">
                    <ShieldCheckIcon className="h-8 w-8 text-blue-600 mr-3" data-id="element-2790" />
                    <div data-id="element-2791">
                      <div className="font-medium" data-id="element-2792">CaseTrust Accredited</div>
                      <div className="text-sm text-gray-500" data-id="element-2793">
                        Consumer Protection
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-2794">
                <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2795">
                  Why Choose Us
                </h3>
                <ul className="list-disc pl-5 space-y-2 text-gray-700" data-id="element-2796">
                  <li data-id="element-2797">All devices undergo rigorous 70+ quality checks</li>
                  <li data-id="element-2798">Extended warranty on all certified products</li>
                  <li data-id="element-2799">Competitive pricing with price-match guarantee</li>
                  <li data-id="element-2800">Fast shipping and delivery options</li>
                  <li data-id="element-2801">Professional customer service team</li>
                  <li data-id="element-2802">
                    Sustainable business practices with reduced carbon footprint
                  </li>
                </ul>
              </div>
            </div>
          </div>}
        {/* Policies Tab */}
        {activeTab === 'policies' && <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-2803">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-2804">Policies</h2>
            <div className="space-y-6" data-id="element-2805">
              <div data-id="element-2806">
                <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2807">
                  Shipping Policy
                </h3>
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2808">
                  <ul className="space-y-2 text-gray-700" data-id="element-2809">
                    <li data-id="element-2810">
                      <span className="font-medium" data-id="element-2811">Standard Shipping:</span>{' '}
                      1-3 business days (Free for orders over $50)
                    </li>
                    <li data-id="element-2812">
                      <span className="font-medium" data-id="element-2813">Express Shipping:</span>{' '}
                      Next business day ($15)
                    </li>
                    <li data-id="element-2814">
                      <span className="font-medium" data-id="element-2815">Same-day Delivery:</span>{' '}
                      Available for orders placed before 2 PM ($25)
                    </li>
                    <li data-id="element-2816">All orders are processed within 24 hours</li>
                  </ul>
                </div>
              </div>
              <div data-id="element-2817">
                <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2818">
                  Return Policy
                </h3>
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2819">
                  <ul className="space-y-2 text-gray-700" data-id="element-2820">
                    <li data-id="element-2821">
                      <span className="font-medium" data-id="element-2822">Return Window:</span> 14
                      days from delivery date
                    </li>
                    <li data-id="element-2823">
                      <span className="font-medium" data-id="element-2824">Condition:</span> Item must
                      be in original condition with all accessories
                    </li>
                    <li data-id="element-2825">
                      <span className="font-medium" data-id="element-2826">Refund Method:</span>{' '}
                      Original payment method
                    </li>
                    <li data-id="element-2827">
                      <span className="font-medium" data-id="element-2828">Processing Time:</span> 3-5
                      business days after item is received
                    </li>
                    <li data-id="element-2829">Return shipping is free for defective items</li>
                  </ul>
                </div>
              </div>
              <div data-id="element-2830">
                <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2831">
                  Warranty Policy
                </h3>
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2832">
                  <ul className="space-y-2 text-gray-700" data-id="element-2833">
                    <li data-id="element-2834">
                      <span className="font-medium" data-id="element-2835">
                        Certified Refurbished:
                      </span>{' '}
                      6-month warranty
                    </li>
                    <li data-id="element-2836">
                      <span className="font-medium" data-id="element-2837">Brand New:</span> Full
                      manufacturer warranty
                    </li>
                    <li data-id="element-2838">
                      <span className="font-medium" data-id="element-2839">Used Items:</span> 30-day
                      warranty
                    </li>
                    <li data-id="element-2840">Extended warranty options available at checkout</li>
                    <li data-id="element-2841">Warranty covers hardware defects and malfunctions</li>
                  </ul>
                </div>
              </div>
              <div data-id="element-2842">
                <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-2843">
                  Payment Methods
                </h3>
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2844">
                  <p className="text-gray-700 mb-3" data-id="element-2845">
                    We accept the following payment methods:
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-2846">
                    <div className="bg-white px-3 py-2 rounded border border-gray-200" data-id="element-2847">
                      Credit/Debit Cards
                    </div>
                    <div className="bg-white px-3 py-2 rounded border border-gray-200" data-id="element-2848">
                      PayPal
                    </div>
                    <div className="bg-white px-3 py-2 rounded border border-gray-200" data-id="element-2849">
                      Apple Pay
                    </div>
                    <div className="bg-white px-3 py-2 rounded border border-gray-200" data-id="element-2850">
                      Google Pay
                    </div>
                    <div className="bg-white px-3 py-2 rounded border border-gray-200" data-id="element-2851">
                      Bank Transfer
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
      {/* Chat Button (Mobile) */}
      <div className="fixed bottom-6 right-6 md:hidden" data-id="element-2852">
        <button className="bg-red-500 text-white rounded-full p-4 shadow-lg hover:bg-red-600 transition-colors" data-id="element-2853">
          <MessageCircleIcon className="h-6 w-6" data-id="element-2854" />
        </button>
      </div>
      <style jsx data-id="element-2855">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};